export const giftback = {
	giftbacks: {
		title: "Campanhas de giftback",
		description: "Crie e gerencie as suas campanhas de giftback.",
		createGiftback: "Criar giftback",
		searchPlaceholder: "Buscar por nome da campanha",
		deleteConfirm: "Tem certeza que deseja excluir giftback?",
		deleteGiftback: "Excluir giftback",
		steps: {
			general: {
				title: "Configurações gerais",
			},
			resume: {
				title: "Resumo",
			},
		},
		emptyState: {
			title: "Não tem nada por aqui...",
			description: "Ajuste o filtro de busca ou adicione uma nova campanha de giftback.",
		},
		buttonsTitle: {
			createAndActivateLater: "Criar e ativar depois",
			createAndActivateNow: "Criar e ativar giftback",
			saveChanges: "Salvar alterações",
		},
		feedbackerros: {
			selectAtLeastOnePlace: "Selecione pelo menos um local",
			maxCharactersName: "Máximo de 50 caracteres",
		},
		form: {
			active: "Ativar giftback",
			name: "Nome da campanha",
			namePlaceHolder: "Digite o nome da campanha",
			minimumConsumptionLabel: "Valor mínimo de consumo",
			minimumConsumptionTooltip:
				"Valor que o cliente deve consumir para converter em giftback.",
			percentageLabel: "Porcentagem",
			percentageTooltip:
				"Quanto do valor consumido pelo cliente será presenteado ao mesmo.",
			expiresInLabel: "Prazo para expirar o giftback",
			expiresInTooltip:
				"Quantidade máxima de dias em que o cliente deve utilizar o giftback.",
			expiresInPlaceholder: "Selecione o prazo para expirar o giftback",
			expiresAtLabel: "Período do resgate",
			expiresAtTooltip: "Tempo que o cliente terá para aproveitar o giftback.",
			expiresAtPlaceholder: "Selecione o período de validade do giftback",
			placeLabel: "Locais participantes",
			removeGiftback: "Remover giftback",
			selectAll: "Selecionar todos",
			day: "dia",
			days: "dias",
			week: "semana",
			noValidity: "Sem validade",
			selectAllPlacesDescription:
				"Selecione os locais onde o giftback estará disponível.",
			shouldConsiderEntranceLabel: "Incluir entradas no cálculo do Giftback",
		},
		tabs: {
			addNewGiftback: "Adicionar novo giftback",
		},
	},
	giftbackReport: {
		selectGiftbackLabel: "Campanha",
		selectGiftbackPlacholder: "Selecione a(s) campanha(s)",
		table: {
			createdAt: "Criado em",
			giftback: "Campanha",
			messagesSent: "Sms enviados",
			places: "Locais",
			rescues: "Resgates",
			totalValue: "{{ currencySymbol }} em vendas",
			giftbackSent: "Total de giftbacks",
			giftbackValue: "{{ currencySymbol }} giftback resgatado",
			conversionRate: "Taxa de conversão",
		},
		title: "Relatório de resgates",
		totalizers: {
			quantity: "Campanhas criadas",
			totalSms: "Total de SMS criados",
			totalRescues: "Total de resgates",
			totalSales: "Total em vendas utilizando giftback",
		},
	},
	giftbackPowerBi: {
		title: "Relatório de Giftback",
	},
};
